/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".addressChangeBtn[_ngcontent-%COMP%]{white-space:initial;padding:0 20px;min-width:140px;margin:8px;width:100%}.allowFlex[_ngcontent-%COMP%]{display:-ms-inline-flexbox;display:inline-flex}.allowFlex[_ngcontent-%COMP%]   .addressChangeBtn[_ngcontent-%COMP%]{width:inherit}.addressChangeBtnContainer[_ngcontent-%COMP%]{text-align:center;margin:0 auto;-ms-flex-align:center;align-items:center}"];
export { styles as styles };
